import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api.js';

export default function Terms() {
  const [legal, setLegal] = useState(null);
  useEffect(() => { api.legal().then(setLegal).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-navy text-white">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-white no-underline">
            <svg width="32" height="32" viewBox="0 0 64 64" aria-hidden="true">
              <rect width="64" height="64" rx="10" fill="#DBC078"/>
              <path d="M14 46 L32 14 L50 46 Z" fill="none" stroke="#032953" strokeWidth="4" strokeLinejoin="round"/>
              <circle cx="32" cy="32" r="4" fill="#032953"/>
            </svg>
            <div>
              <div className="font-bold tracking-tight">MAPTRIUM™</div>
              <div className="text-[10px] text-white/60 uppercase tracking-widest">by Atlas Geo</div>
            </div>
          </Link>
          <Link to="/login" className="text-sm text-gold underline">Back to sign-in</Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-10">
        {!legal ? (
          <div className="text-ink-muted">Loading…</div>
        ) : (
          <article className="bg-white rounded-xl shadow p-8">
            <div className="tag tag-gold mb-2">Legal</div>
            <h1 className="text-3xl font-bold text-navy">Terms of Service</h1>
            <p className="text-sm text-ink-muted mt-1">
              {legal.product} — a product of {legal.company}. Effective {legal.effective_date}.
            </p>

            <div className="mt-4 p-4 bg-amber-50 border-l-4 border-amber-500 rounded">
              <h2 className="font-bold text-amber-900 mb-1">Plain-language summary</h2>
              <p className="text-sm text-amber-900">{legal.signup_short}</p>
            </div>

            <div className="mt-8 space-y-6">
              {legal.sections.map((s, i) => (
                <section key={i}>
                  <h2 className="text-xl font-bold text-navy mb-2">{i + 1}. {s.heading}</h2>
                  <p className="text-sm text-ink leading-relaxed">{s.body}</p>
                </section>
              ))}
            </div>

            <p className="mt-10 text-xs text-ink-muted italic border-t border-slate-200 pt-4">
              These terms supersede any prior statements. Atlas Geo Technologies may update them on 30 days
              written notice to active subscribers. The current version always lives at this URL.
            </p>
          </article>
        )}
      </main>
    </div>
  );
}
